var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kraken-title-wrapper"},[_c('h2',{staticClass:"kraken-title"},[_c('span',{staticClass:"kraken-title-textparent"},[_vm._v(" "+_vm._s(_vm.titleText)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }